<template>
    <div>
        <backTitleBar></backTitleBar>
        <div class="shop-info" style="background: #83C221;">
            <div class="info-item">
                <div class="title" style="font-size:.36rem">{{qryShopName}}</div>
            </div>
            <div class="info-bottom">
               <div class="info-item">
                  <div class="title">销售额(元)</div>
                  <div class="number number_font">{{formatNumber(totalSaleMoney || 0)}}</div>
               </div>
               <div class="info-item">
                  <div class="title">订单量</div>
                  <div class="number number_font">{{formatNumber(orderNum || 0)}}</div>
               </div>
            </div>  
        </div>
        <div class="page-flex">
            <div class="page-user">
               <div class="card">
                <div>
                    <div class="card-table-header">
                        <div class="table-index">商品名称</div>
                        <div class="table-main">订单量</div>
                        <div class="table-number">销售额</div>
                    </div>
                    <ul>
                        <li class="li-item" v-for="(item,$index) in saleList" :key="$index">
                            <div class="table-index">{{item.productName}}</div>
                            <div class="table-main">{{item.orderNum}}</div>
                            <div class="table-number">{{item.totalSaleMoney}}</div>
                        </li>
                    </ul>
                </div>
            </div>
          </div>
        </div>
        <!-- <div style="height: 0.95rem"></div> -->
        <!-- <tabber :tabActive="1"></tabber> -->
    </div>
</template>

<script>
    import routerBack from "@/mixins/routerBack"
    import backTitleBar from "@/components/titleBar/backTitleBar"
    import {qrySaleByDimension, qryRank} from "@/api/data"
    import tabber from '@/view/data/product/index'
    export default {
        name: "onlyEquipment",
        mixins: [routerBack],
        components:{tabber, backTitleBar},
         data() {
            return {
                tabList:[
                    {name:'商品排行',value: 1},
                    {name:'设备排行',value: 2},
                ],
                tabTimeList:[
                    {name:'日',value: 3},
                    {name:'月',value: 2},
                    {name:'年',value: 1}
                ],
                tabActive: 1,
                tabTimeActive: 3,
                saleList: [],
                time: '',
                qryShopName: '',
                orderNum:'',
                totalSaleMoney:'',
                time:'',
                dimension:''
            }
        },
        mounted() {
           let _this = this; 
           let temp_date = new Date();
           let temp_year1 = temp_date.getFullYear();
           let temp_month1 = (temp_date.getMonth()+1) > 9 ? (temp_date.getMonth()+1) : "0" + (temp_date.getMonth()+1);
           let temp_day1 = (temp_date.getDate()) > 9 ? (temp_date.getDate()) : "0" + (temp_date.getDate());
           let curTime = temp_year1.toString() + temp_month1.toString() + temp_day1.toString();
           this.time = curTime;
           this.qryShopName = this.$route.query.qryShopName;
           this.orderNum = this.$route.query.orderNum;
           this.totalSaleMoney = this.$route.query.totalSaleMoney;
           this.time = this.$route.query.time;
           this.dimension = this.$route.query.dimension;

        //    let params = {
        //       curTime: curTime,
        //       dimension: 3,
        //       qryFlag: 1,
        //       qryShopName: this.qryShopName
        //    }
        //    qrySaleByDimension(params).then(res=>{
        //        if(res.code == 0){
        //           this.saleList = res.data.records
        //        }
        //    })

          
           let params2 = {
              qryTime: this.time,
              dimension: this.dimension,
              qtype: 0,
              qryType: 0,
              qryShopName: this.qryShopName,
              dataType: 0
           }
           qryRank(params2).then(res=>{
               if(res.code == 0){
                  this.saleList = res.data.records
               }
           })

        },
        methods: {

          timeChange2(e){
             this.times = e;
            if(e){
            let time = e.split('-').join('');

            let params = {
              qryTime: time,
              dimension: this.tabTimeActive,
              qtype: 0,
              qryType: 0,
              dataType: 0
           }
           qryRank(params).then(res=>{
               if(res.code == 0){
                  this.saleList = res.data.records
               }
             })
            }
           },
        },
    }
</script>

<style scoped lang="scss">
    .shop-top{
        padding-top: .25rem;
        display: flex;
        flex-direction: row;
        .shopName{
            color: #eee;
            font-size: .32rem;
            line-height: .45rem;
            padding-bottom: .05rem;
            margin-bottom: .25rem;
            margin-left: .4rem;
           
        }
        .active{
            color: #fff;
            border-bottom: .05rem solid #fff;
        }
    }
    .page-text-d{
           float: left;
           font-size: .34rem;
           font-weight: bold;
           margin: .28rem .28rem;
           border-left: .04rem solid #83C221;
           padding-left: .1rem;
        }
     .shop-info{
        padding-top: .37rem;
        .zuori{
            font-size: .24rem;
            font-weight: 400;
            line-height: .47rem;
            width: 2.52rem;
            height: .47rem;
            background: rgba(0,0,0,0.1);
            border-radius: .27rem;
            display: block;
            margin: 0 auto;
        }
        .shopName{
            color: #eee;
            font-size: .32rem;
            line-height: .45rem;
            padding-bottom: .05rem;
            margin-bottom: .15rem;
            margin-left: .4rem;
           
        }
        .active{
            color: #fff;
            border-bottom: .05rem solid #fff;
        }
        .info-item{
            color: #fff;
            padding-bottom: .28rem;
            text-align: center;
            .title{
                color: #eee;
                font-size: .26rem;
                line-height: .4rem;
            }
            .number{
                padding-top: .11rem;
                font-size: .52rem;
            }
        }
    }
    .info-bottom{
        display: flex;
        .info-item{
            flex: 1;
            text-align: center;
        }
    }
    .page-flex{
        background: #eee;
        .page-data{
            background: #fff;
            height: 2.28rem;
            border-radius: .24rem;
        }
        .page-user{
            margin: .2rem 0;
            background: #fff;
            height: 9.16rem;
            border-radius: .24rem;
        }
    }
    .card{
        //width: 7rem;
        //margin: 0 .25rem;
        background: #fff;
        border-radius: .24rem;
        padding: .28rem .26rem;
        .card-title{
            font-size: .34rem;
            line-height: .48rem;
            color: #252D46;
            font-weight: bold;
        }
        .card-tab{
            display: flex;
            margin-top: .2rem;
            padding-bottom: .2rem;
            .tab-item{
                margin-right: .5rem;
                font-size: .3rem;
                line-height: .45rem;
                color: #919BA6;
                &.active{
                    position: relative;
                    color: #252D46;
                    &:after{
                        position: absolute;
                        content: '';
                        width: .82rem;
                        height: .06rem;
                        background: #1FC581;
                        border-radius: .03rem;
                        bottom: -.15rem;
                        left: 0;
                    }
                }
            }
        }
    }
    .card-table-header{
        margin-top: .25rem;
        display: flex;
        background: #F5F6FA;
        border-radius: .14rem;
        padding: .16rem .2rem;
        font-size: .28rem;
        line-height: .4rem;
        color: #666;
    }
    .table-index{
        width: 2.6rem;
        margin-right: .2rem;
    }
    .table-main{
        flex: 1;
        margin-right: .1rem;
    }
    .table-number{
        width: 1.5rem;
    }
    .li-item{
        display: flex;
        font-size: .32rem;
        line-height: .45rem;
        color: #333;
        padding: .15rem .2rem;
        .table-number{
            color: $org;
        }
    }
    .page-data-time{
        display: block;
        margin: 0 auto;
    }
    .page-data-top{
        width: 94%;
        height: .68rem;
        display: flex;
        flex-direction: row;
        margin: .3rem .24rem;
        border-radius: .12rem;
        border: .03rem solid #1FC581;
    }
    .page-data-div{
        flex: auto;
        font-size: .28rem;
        text-align: center;
        line-height: .68rem;
        &:first-child{
          border-right: .03rem solid #1FC581;
        }
        &:nth-child(2){
          border-right: .03rem solid #1FC581;
        }
        &.active{
            color: #fff;
            background: #1FC581;
        }
    }
</style>


// WEBPACK FOOTER //
// onlyEquipment.vue?3e78ba51